import { useState, useCallback } from 'react';
import { 
  generateInvoicePDF, 
  downloadInvoicePDF, 
  getInvoicePDFAsBase64,
  printInvoicePDF
} from '../utils/puppeteerPDFGenerator';

export const useInvoicePDF = () => {
  const [isGenerating, setIsGenerating] = useState(false);
  const [error, setError] = useState(null);

  const generatePDF = useCallback(async (invoiceDetails, selectedOrganization, options = {}) => {
    setIsGenerating(true);
    setError(null);
    
    try {
      const pdf = await generateInvoicePDF(invoiceDetails, selectedOrganization, options);
      setIsGenerating(false);
      return pdf;
    } catch (err) {
      setError(err.message);
      setIsGenerating(false);
      throw err;
    }
  }, []);

  const downloadPDF = useCallback(async (invoiceDetails, selectedOrganization, filename) => {
    setIsGenerating(true);
    setError(null);
    
    try {
      const success = await downloadInvoicePDF(invoiceDetails, selectedOrganization, filename);
      setIsGenerating(false);
      return success;
    } catch (err) {
      setError(err.message);
      setIsGenerating(false);
      throw err;
    }
  }, []);

  const getPDFAsBase64 = useCallback(async (invoiceDetails, selectedOrganization) => {
    setIsGenerating(true);
    setError(null);
    
    try {
      const base64PDF = await getInvoicePDFAsBase64(invoiceDetails, selectedOrganization);
      setIsGenerating(false);
      return base64PDF;
    } catch (err) {
      setError(err.message);
      setIsGenerating(false);
      throw err;
    }
  }, []);

  const printPDF = useCallback(async (invoiceDetails, selectedOrganization) => {
    setIsGenerating(true);
    setError(null);
    
    try {
      const success = await printInvoicePDF(invoiceDetails, selectedOrganization);
      setIsGenerating(false);
      return success;
    } catch (err) {
      setError(err.message);
      setIsGenerating(false);
      throw err;
    }
  }, []);

  return {
    generatePDF,
    downloadPDF,
    printPDF,
    getPDFAsBase64,
    isGenerating,
    error
  };
};